import script from "./FavoritesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritesPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__